import React from 'react';
import {
  Card,
  Icon,
  Statistic,
  Grid,
} from 'semantic-ui-react';
import numeral from 'numeral';

const cf = (num) => numeral(num).format('0,0');

const ReportSummary = ({ data }) => (
  <Card fluid style={{marginBottom:50}} color="pink">
    <Card.Content>
      <Card.Header>
        Summary
      </Card.Header>
      <Card.Meta>
        engagements and viewing across YouTube and supporting social activities
      </Card.Meta>
    </Card.Content>
    <Card.Content>
      <Grid>
        <Grid.Row>
          <Grid.Column computer={7} mobile={15} className="text-centered-responsive" textAlign="right" verticalAlign="middle">
            <Statistic color="pink">
            <Statistic.Value>
              { cf(data.totalEngagements) }
            </Statistic.Value>
            <Statistic.Label>
            <Icon name='like' />
              total engagements
            </Statistic.Label>
            </Statistic>
          </Grid.Column>
          <Grid.Column width={1} verticalAlign="middle">
            &nbsp;
          </Grid.Column>
          <Grid.Column computer={7} mobile={15} textAlign="center" verticalAlign="middle">
            <Statistic color="pink">
              <Statistic.Value>
                { cf(data.totalViews) }
              </Statistic.Value>
              <Statistic.Label>
              <Icon name='youtube play' />
                total views
              </Statistic.Label>
            </Statistic>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Content>
    <Card.Content textAlign="center">
      <a rel="noopener noreferrer"
        href="https://dyzio.co"
        target="_blank">
        influencer analytics - powered by dyzio
      </a>
    </Card.Content>
  </Card>
)

export default ReportSummary;



// WEBPACK FOOTER //
// ./src/components/report-summary/index.js